module.exports = __webpack_public_path__ + "img/Big5Cats_EGM.901201bc.png";